import React from 'react';
import { ArrowBack } from '@material-ui/icons';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';

/**
 * Shared back button component for all Monamodi amendment pages
 * Displays a small, unobtrusive back button in the top-right corner
 *
 * @param {Function} onClick - Handler function when back button is clicked
 */
const BackButton = ({ onClick }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
      <ButtonInc
        btnType="text"
        onClick={onClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 12px',
          fontSize: '13px',
          color: '#666',
          textTransform: 'none'
        }}
      >
        <ArrowBack style={{ fontSize: '16px' }} />
        Back
      </ButtonInc>
    </div>
  );
};

export default BackButton;
